import { render } from "./AccueilView.vue?vue&type=template&id=33e23702&scoped=true"
import script from "./AccueilView.vue?vue&type=script&lang=js"
export * from "./AccueilView.vue?vue&type=script&lang=js"

import "./AccueilView.vue?vue&type=style&index=0&id=33e23702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e23702"]])

export default __exports__